import React from 'react';
import styles from './ErrorAlert.module.scss';
import CloseButton from './CloseButton';
import ErrorIcon from './ErrorIcon';
import ErrorAlertContainer, { AlertVariant } from './ErrorAlertContainer';

export function TitleAlert(props: {
  titleText: string;
  dismissable: boolean;
  contentText?: React.ReactNode[] | React.ReactNode;
  onDismissed?: () => void;
  variant?: AlertVariant;
}) {
  return (
    <ErrorAlertContainer
      dismissable={props.dismissable}
      variant={props.variant}
    >
      <div>
        <ErrorIcon variant={props.variant} />
        <strong>
          <span className={`${styles['title']} ${styles['text']}`}>
            {props.titleText}
          </span>
        </strong>

        {props.dismissable ? <CloseButton onClick={props.onDismissed} /> : null}
      </div>

      <Content {...props} />
    </ErrorAlertContainer>
  );
}

function Content(props: { contentText?: React.ReactNode[] | React.ReactNode }) {
  if (!props.contentText) {
    return null;
  }

  if (
    typeof props.contentText === 'string' ||
    React.isValidElement(props.contentText)
  ) {
    return (
      <div className={`${styles['content']} ${styles['text']}`}>
        {props.contentText}
      </div>
    );
  }

  return (
    <span>
      <ul>
        {(props.contentText as React.ReactNode[]).map((node, index) => (
          <li key={index}>
            <div className={styles['text']}>{node}</div>
          </li>
        ))}
      </ul>
    </span>
  );
}
